import { Collapse, Typography } from '@material-ui/core'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import { STATS_DISPLAY_TYPE } from '../../../constants'

const STAT_COLOURS = [
  '#00a8d5',
  '#0090b1',
  '#067a8e',
  '#09607b',
  '#09495e',
  '#063e4b',
  '#242f3a',
]

const getColours = (num) => {
  switch (num) {
    case 3:
      return Object.values(_.pick(STAT_COLOURS, [0, 3, 6]))
    case 4:
      return Object.values(_.pick(STAT_COLOURS, [0, 2, 4, 6]))
    case 5:
      return Object.values(_.pick(STAT_COLOURS, [0, 1, 3, 5, 6]))
    case 6:
      return Object.values(_.pick(STAT_COLOURS, [0, 1, 2, 3, 5, 6]))
    case 7:
      return STAT_COLOURS
  }
}

const StatBar = ({ year, value, change, color, stats, deviceWidth, baseHeight }) => {
  const [show, setShow] = useState(false)
  const desktop = isWidthUp('md', deviceWidth)
  const max = Math.max(
    ...stats.map((item) => item[STATS_DISPLAY_TYPE === 'number' ? 'value' : 'change'])
  )
  const scaleFactor = stats.length * 1.5
  const barStretch = desktop ? 0.5 : 0.7 // between 0.01 and 1
  const barValue = STATS_DISPLAY_TYPE === 'number' ? value : change
  const barHeight =
    (baseHeight * (barValue - max * barStretch)) / ((1 - barStretch) * max)
  const displayValue =
    STATS_DISPLAY_TYPE === 'number'
      ? barValue.toLocaleString('en-GB')
      : (barValue * 100).toFixed(1) + '%'

  const widths = desktop
    ? [74, 37, 30]
    : [
        screen.width / scaleFactor,
        screen.width / (scaleFactor * 2),
        screen.width / (scaleFactor * 2.5),
      ]

  useEffect(() => {
    setTimeout(() => setShow(true), 500 + 500 * Math.random())
  }, [])

  return (
    <Collapse in={show}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div>
          <Typography variant="h5" style={{ fontSize: desktop ? 20 : 14 }}>
            {displayValue}{' '}
          </Typography>
        </div>
        <div>
          <div
            style={{
              boxSizing: 'border-box',
              borderBottom: `${widths[2]}px solid ${color}`,
              borderRight: `${widths[1]}px solid transparent`,
              borderLeft: `${widths[1]}px solid transparent`,
            }}
          />
          <div
            style={{
              background: color,
              width: widths[0],
              height: barHeight,
            }}
          />
        </div>
        <div
          style={{
            background: color,
            width: widths[0],
            height: 24,
            color: 'white',
            textAlign: 'center',
            marginTop: 10,
          }}
        >
          <Typography variant="subtitle1">{year}</Typography>
        </div>
      </div>
    </Collapse>
  )
}

const StatsChart = ({ stats, width }) => {
  const base = Object.keys(stats).filter((key) => key.includes('number'))
  const colours = getColours(base.length)
  const desktop = isWidthUp('md', width)
  const barHeight = desktop ? 250 : 120 // px

  const statsArray = base.map((key, idx) => {
    const twoYears = ''.concat(key.split('_')[1])
    return {
      value: Number(stats[key]),
      change: stats[key.replace('number', 'percentage')],
      color: colours[idx],
      year: '20' + twoYears.slice(4, 6),
    }
  })

  return (
    <Fade in={!!stats}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justify="flex-end"
        style={{ minHeight: barHeight + 100, margin: desktop ? 'inherit' : '12px 0' }}
        spacing={1}
      >
        <Grid
          item
          container
          direction="row"
          alignItems="flex-end"
          spacing={desktop ? 2 : 1}
        >
          {statsArray.map((stat, idx) => (
            <Grid item key={idx}>
              <StatBar
                {...stat}
                deviceWidth={width}
                stats={statsArray}
                baseHeight={barHeight}
              />
            </Grid>
          ))}
        </Grid>
        <Grid item>
          <Typography variant="caption">
            {`${
              STATS_DISPLAY_TYPE === 'number' ? 'Number' : 'Percentage'
            } of children in child poverty`}
          </Typography>
        </Grid>
      </Grid>
    </Fade>
  )
}

export default withWidth()(StatsChart)
